import background_image_mobile from "../../images/clean-browser-mockup-mobile.png";
import background_image_desktop from "../../images/clean-browser-mockup.png";
export function LandingParallaxComponent() {
  return (
    <div className="flex w-full h-[500px] bg-wrap">
      <section className="flex flex-col w-full h-[500px] bg-cover bg-center flex justify-center items-center parallax-section"></section>
    </div>
  );
}
